
















import {
  Component,
  Prop,
  Ref,
  Vue as VueDecorator,
} from "vue-property-decorator";
import TextInputDialogComponent from "@/components/common/TextInputDialog.vue";

@Component({
  components: {
    "text-input-dialog": TextInputDialogComponent,
  },
})
export default class ClickableTextFieldComponent extends VueDecorator {
  isDialogOpen = false;

  @Prop()
  title!: string;

  @Prop()
  message!: string;

  @Prop()
  label!: string;

  @Prop()
  value!: string;

  @Prop({ default: null })
  inputValidation!: null | ((input: string) => string | null);

  @Prop({ default: "text" })
  inputType!: string;

  @Prop({ default: undefined })
  min!: number | undefined;

  @Ref("textInputDialog")
  textInputDialogComponent!: TextInputDialogComponent;

  async showTextInputDialog() {
    const result = await this.textInputDialogComponent.show(
      this.value,
      this.title,
      this.message,
      this.label,
      this.inputValidation,
      this.inputType,
      this.min
    );

    this.$emit("onNewInput", result);
  }
}
